/**
 * CAPTCHA Configuration for reCAPTCHA v3 (primary) and v2 (fallback)
 * Site keys are environment-specific; enablement comes from customer configuration.
 * Uses import.meta.env for Vite compatibility
 */
export const CAPTCHA_CONFIG = {
  siteKey: import.meta.env.REACT_APP_RECAPTCHA_SITE_KEY || "", // v3 site key
  v2SiteKey: import.meta.env.REACT_APP_RECAPTCHA_V2_SITE_KEY || "", // v2 fallback key
};
